<template>
    <div class="modal fade" id="editEmployeePresence" role="dialog" aria-labelledby="createTaskModallLabel"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editEmployeePresenceLabel">{{$t('presenceForm.absence')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form v-if="!isSaving">
                    <div class="modal-body">
                        <div class="col-md-12 bmd-form-group">
                            <div class="font-weight-bold required" for="'dateAbsence' + uid">
                                {{$t('presenceForm.dateAbsence')}}
                            </div>
                            <date-only-picker :showTime="false"
                                              v-validate="'required'"
                                              :fieldName="$t('presenceForm.dateAbsence')"
                                              :name="'dateAbsence' + _uid"
                                              :data-vv-as="$t('presenceForm.dateAbsence')"
                                              v-model="model.absenceDate"
                                              ></date-only-picker>
                            <span class="text-danger" v-if="errors.has('dateAbsence' + _uid)">{{ errors.first('dateAbsence' + _uid) }}</span>
                        </div>
                        <div class="col-md-12 bmd-form-group">
                            <div class="font-weight-bold required" for="'dateEndAbsence' + uid">
                                {{$t('presenceForm.dateEndAbsence')}}
                            </div>
                            {{ model.absenceEndDate }}
                            <date-only-picker :showTime="false"
                            v-validate="'required'"
                            :fieldName="$t('presenceForm.dateEndAbsence')"
                            :name="'dateEndAbsence' + _uid"
                            :data-vv-as="$t('presenceForm.dateEndAbsence')"
                            v-model="model.absenceEndDate"></date-only-picker>
                            <span class="text-danger" v-if="errors.has('dateEndAbsence' + _uid)">{{ errors.first('dateEndAbsence' + _uid) }}</span>
                        </div>
                        <div class="col-md-12 bmd-form-group">
                            <div class="font-weight-bold required" for="'absenceType' + uid">
                                {{$t('presenceForm.absenceType')}}
                            </div>
                            <nomenclature-dropdown :load-by-parent-sort="true"
                                                   :parent-sort="nomenclature.AbsenceType"
                                                   v-model="model.absenceTypeId"
                                                   :required="true"
                                                   :fieldName="$t('presenceForm.absenceType')"
                                                   :name="'absenceType' + _uid"></nomenclature-dropdown>
                        </div>
                        <div class="col-md-12 bmd-form-group">
                            <div class="font-weight-bold" for="'reasonForAbsence' + uid">
                                {{$t('presenceForm.reasonForAbsence')}}
                            </div>
                            <input type="text" v-model="model.reasonForAbsence" class="form-control">
                        </div>
                        <div class="col-md-12 bmd-form-group" v-if="!model.allEmployees">
                            <div class="font-weight-bold" for="'replacement' + uid">
                                {{$t('presenceForm.replacement')}}
                            </div>
                            <dynamicDropdown :apiUrl="`/api/employee/GetEmployees`"
                                             :registerName="$t('registers.employees.title')"
                                             v-model="model.substitutionEmployeeId"
                                             :name="'replacement' + _uid"
                                             :data-vv-as="$t('presenceForm.replacement')"
                                             :fieldName="$t('presenceForm.replacement')">
                            </dynamicDropdown>
                        </div>
                        <div class="col-md-12 bmd-form-group" v-if="!model.allEmployees">
                            <div class="font-weight-bold" for="'reasonForReplacement' + uid">
                                {{$t('presenceForm.reasonForReplacement')}}
                            </div>
                            <input type="text" v-model="model.reasonForReplacement" class="form-control">
                        </div>
                        <div class="col-md-12 bmd-form-group">
                            <div class="font-weight-bold" for="'reasonForReplacement' + uid">
                                {{$t('presenceForm.creatorUsername')}}
                            </div>
                            <input type="text" v-model="model.userId" readonly class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer justify-content-around">
                        <div v-if="model.id">
                            <button type="button" class="btn btn-danger" @click="remove">
                                {{$t('presenceForm.removeAbsence')}}
                            </button>
                        </div>
                        <div v-if="model.allEmployees">
                            <button type="button" class="btn btn-danger" @click="removeAll">
                                {{$t('presenceForm.removeAllAbsence')}}
                            </button>
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary" @click="onSubmit">
                                {{$t('buttons.save.btnText')}}
                            </button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{$t('buttons.cancel')}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { Absence } from "../../models/models";
    import NomenclatureDropdown from "../dropdown/NomenclatureDropdown";
    import DynamicDropdown from "../dropdown/DynamicDropdown";
    import DateOnlyPicker from "@/components/datepicker/DateOnlyPicker";
    import { NomenclatureParentBySort } from '../../models/enums';

    export default {
        data() {
            return {
                isSaving: false,
                nomenclature: NomenclatureParentBySort
            };
        },
        props: {
            absenceDate: {
                type: Date,
            },
            show: {
                type: Boolean,
                default: false
            },
            model: Absence
        },
        components: {
            NomenclatureDropdown,
            DynamicDropdown,
            DateOnlyPicker
        },
        methods: {
            onClose() {
                this.model = new Absence();
                this.$emit('onClose');
            },
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.create();
                    }
                })
            },
            create() {
                this.isSaving = true;
                this.$http.post('/api/presenceForm', this.model).then(result => {
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.isSaving = false;
                    this.onClose();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                    this.isSaving = false;
                    this.onClose();
                });
            },
            remove() {
                kendo.confirm(`${this.$t('presenceForm.removeAbsenceConfirm')}`)
                    .then(function () {
                        this.doRemove();
                    }.bind(this));
            },
            removeAll() {
                kendo.confirm(`${this.$t('presenceForm.removeAllAbsenceConfirm')}`)
                    .then(function () {
                        this.doRemoveAll();
                    }.bind(this));
            },
            doRemove() {
                this.isSaving = true;
                this.$http.put('/api/presenceForm/remove', this.model).then(result => {
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.isSaving = false;
                    this.onClose();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                    this.isSaving = false;
                    this.onClose();
                });
            },
            doRemoveAll() {

                this.isSaving = true;
                this.$http.put('/api/presenceForm/removeAll', this.model).then(result => {
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.isSaving = false;
                    this.onClose();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                    this.isSaving = false;
                    this.onClose();
                });
            }
        },
        watch: {
            show: function (val) {
                if (val) {
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            },
            absenceDate: function (newDate) {
                this.model.absenceDate = newDate.toUTCString();
                this.model.absenceEndDate = newDate.toUTCString();
            },
            'model.absenceEndDate':
            {
                immediate: true,
                handler(newVal) {
                    if (new Date(newVal).getTime() < new Date(this.model.absenceDate).getTime()) {
                        this.model.absenceDate = this.model.absenceEndDate;
                    }
                }
            },
            'model.absenceDate': {
                immediate: true,
                handler(newVal) {
                    if (new Date(newVal).getTime() > new Date(this.model.absenceEndDate).getTime()) {
                        this.model.absenceEndDate = this.model.absenceDate;
                    }
                }
            }
        },
        mounted() {
            $(this.$el).on('hidden.bs.modal', this.onClose);
        }
    }
</script>

<style scoped>
</style>
